import React from "react";
import { Container } from "../components/styled.ts";
import { Typography } from "../components/typography/index.tsx";
import { Header } from "../components/header/index.tsx";
import { Seo } from "../components/seo/index.tsx";
import LinkButton from "../components/linkButton/index.tsx";
import { TelegramIcon } from "../components/icons/telegram.tsx";

const botUsername = (process.env.REACT_APP_TELEGRAM_BOT_USERNAME || "FinQIndiaBot").replace(/^@/, "");
const botUrl = botUsername ? `https://t.me/${botUsername}?start=signup` : "";

const TelegramSignup = () => {
  return (
    <>
      <Seo
        title="NSE & BSE alerts on Telegram | FinQ India"
        path="/telegram"
        noindex
      />
      <Header />
      <Container
        width="min(calc(100% - 40px) , 900px)"
        justifyContent="center"
        margin="20px auto"
        column
        gap={"20px"}
      >
        <Typography
          tag="h1"
          fontFamily="Neue Montreal"
          fontSize={"28px"}
          fontWeight={500}
          lineHeight={"36.4px"}
          letterSpacing={"0.02em"}
          color="#202020"
        >
          NSE & BSE alerts on Telegram
        </Typography>
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize={"18px"}
          fontWeight={400}
          lineHeight={"27px"}
          letterSpacing={"0.02em"}
          color="#828282"
        >
          For investors who want the filing, not the noise. When a company announces results, an order, a dividend, or a board meeting, FinQ sends a short summary to Telegram.
        </Typography>
        <Container width="100%" justifyContent="center">
          <img
            src="/alerts/telegram-alert.png"
            alt="A FinQ India alert on Telegram, with the company, the filing type, and a short summary"
            style={{
              width: "auto",
              height: "480px",
              maxWidth: "100%",
              display: "block",
            }}
          />
        </Container>
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize={"18px"}
          fontWeight={500}
          lineHeight={"36.4px"}
          letterSpacing={"0.02em"}
          color="#202020"
        >
          Follow your stocks, or the whole market
        </Typography>
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize={"18px"}
          fontWeight={400}
          lineHeight={"27px"}
          letterSpacing={"0.02em"}
          color="#828282"
        >
          Save the companies you hold and get alerts only for those names. Or follow every company. Every company is included in the <span style={{ fontWeight: 500, color: "#202020" }}>15-day trial</span> and on a paid plan.
        </Typography>
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize={"18px"}
          fontWeight={400}
          lineHeight={"27px"}
          letterSpacing={"0.02em"}
          color="#828282"
        >
          You still choose which filings arrive. Mute results, orders, dividends, or anything else you do not want.
        </Typography>
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize={"18px"}
          fontWeight={500}
          lineHeight={"36.4px"}
          letterSpacing={"0.02em"}
          color="#202020"
        >
          Start from Telegram
        </Typography>
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize={"18px"}
          fontWeight={400}
          lineHeight={"27px"}
          letterSpacing={"0.02em"}
          color="#828282"
        >
          Open FinQ on Telegram. FinQ sends <span style={{ fontWeight: 500, color: "#202020" }}>Add Stocks to Watch List</span>. Save the companies you follow, or switch to every company.
        </Typography>
        {botUrl ? (
          <Container width="fit-content">
            <LinkButton
              url={botUrl}
              background="#2AABEE"
              border="solid 1px #2AABEE"
              color="#fff"
              icon={<TelegramIcon width="20" height="20" color="#fff" />}
              linkText="Get alerts on Telegram"
            />
          </Container>
        ) : null}
      </Container>
    </>
  );
};

export default TelegramSignup;
